import { UserDataActionType } from '../_actions/UserDataActions';
import type { UserDataAction } from '../_actions/UserDataActions';
import UserPrefsStore from '../_stores/UserPrefsStore';
import type { UserPrefsPayload } from '../_stores/UserPrefsStore';

const UserPrefsReducer = (store:UserPrefsStore = new UserPrefsStore(), action: UserDataAction):UserPrefsStore => {
	switch (action.type) {
		case UserDataActionType.EditUserPrefs: {
			const updates = action.updates as Partial<UserPrefsPayload>;
			const {
				currency,
				addressAtCheckout,
				quickDeleteFromCart,
				massDesignLabSaveDismissed,
				measurementSystem,
				accountProductsLayout,
				accountProductsSort,
				accountPageLimit,
				lang,
			} = updates;
			store = store.withMutations((store) => {
				if(currency !== undefined) store = store.set('currency', currency);
				if(measurementSystem !== undefined) store = store.set('measurementSystem', ['imperial', 'metric'].includes(measurementSystem) ? measurementSystem : 'imperial');
				if(addressAtCheckout !== undefined) store = store.set('addressAtCheckout', !!+addressAtCheckout);
				if(quickDeleteFromCart !== undefined) store = store.set('quickDeleteFromCart', !!+quickDeleteFromCart);
				if(massDesignLabSaveDismissed !== undefined) store = store.set('massDesignLabSaveDismissed', !!+massDesignLabSaveDismissed);
				if(accountProductsLayout !== undefined) store = store.set('accountProductsLayout', ['grid','list'].includes(accountProductsLayout) ? accountProductsLayout : 'grid');
				if(accountProductsSort !== undefined) store = store.set('accountProductsSort', ['n-to-o', 'o-to-n', 'a-to-z', 'z-to-a'].includes(accountProductsSort) ? accountProductsSort : 'n-to-o');
				if(accountPageLimit !== undefined) store = store.set('accountPageLimit', Number(accountPageLimit));
				if(lang !== undefined) store = store.set('lang', lang);
			});
		}
	}
	return store;
}
export default UserPrefsReducer
